import { AuthorizationService } from "@sans-service-tier/authorization-service-sdk";
import Core, { BaseDecodedToken, CoreService } from "@sans-service-tier/sdk";
import { configure } from "@sans-service-tier/sdk-web";

import { env } from "./env";

export class Sans {
  core: CoreService;
  auth: AuthorizationService;

  constructor() {
    const sdkEnv = env.VITE_SDK_ENV ?? "sandbox";
    const remoteConfigUri = env.VITE_REMOTE_CONFIG_URI;

    if (!remoteConfigUri) {
      throw new Error("VITE_REMOTE_CONFIG_URI must be set");
    }

    this.core = this.setupSdk(sdkEnv, remoteConfigUri);
    this.auth = new AuthorizationService(this.core);
  }

  setupSdk(sdkEnv: string, remoteConfigUri: string) {
    configure(Core, {
      window,
      initialEnvironment: {
        [sdkEnv]: {
          uri: remoteConfigUri,
        },
      },
    });

    return Core;
  }

  async isAuthorized(type: string, id = "app", action = "read"): Promise<boolean> {
    try {
      const { authorized } = await this.auth.authorized({
        type,
        id,
        action,
      });

      return authorized;
    } catch (error) {
      console.error("Authorization failed", error);
      return false;
    }
  }

  async getUserId() {
    const userInfo = (await this.core.api.tokens.userInfo()) as BaseDecodedToken & {
      "custom:sans_idp_account_id": string;
    };
    return userInfo["custom:sans_idp_account_id"];
  }

  private static _sdk?: Sans;

  static get sdk(): Sans {
    if (!this._sdk) {
      this._sdk = new Sans();
    }

    return this._sdk;
  }

  static initializeSdk(): void {
    this._sdk = new Sans();
  }
}
